export default __webpack_public_path__ + "static/media/qemotion-logo.5724bb60.png";